import React, { useState } from 'react';

import { Switch } from 'antd';
import classNames from 'classnames';
import localStorageUtil from '$/common/utils/localStorageUtil';
import ReactDOM from 'react-dom';
import { useLanguageStore } from '$/store/languageStore';
import { mtstatTrack } from '$/utils/mtstat';
import styles from './index.module.scss';
import CommonModal from '../CommonModal';
import Radio from '../base/Radio';

// 0: 未设置水印
// 1: 已设置水印
// 2: 关闭弹窗
export type WatermarkState = '0' | '1' | '2';

function DownloadPreferencePopup({ onClose, onConfirm }: { onClose: (hasWatermark: boolean, noRemindActived: boolean) => void; onConfirm: (hasWatermark: boolean, noRemindActived: boolean) => void; }) {
  const languageStore = useLanguageStore((state) => state.languageStore);

  const [hasWatermark, setHasWatermark] = useState(true);
  const [noRemindActived, setNoRemindActived] = useState(false);
  return (
    <CommonModal
      show
      close={() => { onClose(hasWatermark, noRemindActived); }}
      isOpenBlankClick
      content={(
        <div className={styles.DownloadPreferencePopup}>
          <div className={styles.header}>
            {languageStore.smartcatTranslationText((v) => v.roboneo_web_file_saving_preferences)}
          </div>
          <div className={classNames([styles.content, !hasWatermark ? styles.notWatermark : ''])}>
            <div className={styles.titleBox}>
              <div className={styles.titleText}>{languageStore.smartcatTranslationText((v) => v.roboneo_web_includes_AI_watermark)}</div>
              <div className={styles.switchButtonBox}>
                <Switch
                  className={styles.switchButton}
                  checked={hasWatermark}
                  onChange={(checked) => {
                    setHasWatermark(checked);
                  }}
                />
              </div>

            </div>
            <div className={styles.desc}>{languageStore.smartcatTranslationText((v) => v.roboneo_web_watermark_protocol)}</div>
          </div>
          <div className={classNames([styles.footer, !hasWatermark ? styles.notWatermark : ''])}>
            <div
              className={styles.selectButton}
              onClick={() => {
                setNoRemindActived(!noRemindActived);
              }}
            >
              <Radio
                value={noRemindActived}
                onChange={() => {}}
              />
              <div className={styles.text}>
                {}
                {languageStore.smartcatTranslationText((v) => v.roboneo_web_no_remind)}
              </div>
            </div>
            <div
              className={styles.button}
              onClick={() => {
                onConfirm(hasWatermark, noRemindActived);
                if (noRemindActived || !hasWatermark) {
                  localStorageUtil.setItem('RoboneoDownloadHasWatermark', hasWatermark ? '1' : '0');
                }
              }}
            >
              {hasWatermark ? languageStore.smartcatTranslationText((v) => v.roboneo_web_continue) : languageStore.smartcatTranslationText((v) => v.roboneo_web_agree_continue)}
            </div>
          </div>
        </div>
      )}
    />
  );
}

// ✅ 静态方法调用
// 0: 未设置水印
// 1: 已设置水印
// 2: 关闭弹窗
DownloadPreferencePopup.show = function show(): Promise<WatermarkState> {
  return new Promise((resolve) => {
    const catchForHasWatermark = localStorageUtil.getItem('RoboneoDownloadHasWatermark');

    if (catchForHasWatermark) {
      resolve(catchForHasWatermark === '1' ? '1' : '0');
      return;
    }
    mtstatTrack('roboneo_safelike_pop_show', {});
    const container = document.createElement('div');
    document.body.appendChild(container);

    // 创建清理函数
    const cleanup = () => {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
    };

    // 关闭弹窗处理
    const unmount = (hasWatermark: boolean, noRemindActived: boolean) => {
      mtstatTrack('roboneo_safelike_pop_click', {
        ar_mark: hasWatermark ? '1' : '0',
        click_type: 'close',
        is_next_remind: noRemindActived ? '1' : '0',
      });
      resolve('2');
      cleanup();
    };

    // 确认按钮处理
    const handleConfirm = (hasWatermark: boolean, noRemindActived: boolean) => {
      mtstatTrack('roboneo_safelike_pop_click', {
        ar_mark: hasWatermark ? '1' : '0',
        click_type: hasWatermark ? 'agree' : 'disagree',
        is_next_remind: noRemindActived ? '1' : '0',
      });
      resolve(hasWatermark ? '1' : '0'); // 点击继续 → resolve
      cleanup();
    };

    // 使用 React 17 的 render API
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(<DownloadPreferencePopup onClose={unmount} onConfirm={handleConfirm} />, container);
  });
};

export default DownloadPreferencePopup;
